import { Navigate } from 'react-router-dom';

import routes from '../../../../routes/router';
import Introduction from '../Introduction';
import useTimerSteps, { UseTimerSteps } from './vm';

export enum Steps {
  INTRODUCTION,
}

export interface StepsProps extends UseTimerSteps {
  currentStep: Steps;
}

const TimerSteps = ({ currentStep, ...vmProps }: StepsProps) => {
  const { handleClickIntroductionNext, handleGoToTimer } = useTimerSteps(vmProps);

  switch (currentStep) {
    case Steps.INTRODUCTION:
      return <Introduction onNext={handleClickIntroductionNext} goToNextStep={handleGoToTimer} />;
    default:
      return <Navigate to={routes.timer.url()} />;
  }
};

export default TimerSteps;
